var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Page not found")]),_c('p',{staticClass:"subtitle"},[_vm._v("The page you're looking for doesn't exist.")])])
}]

export { render, staticRenderFns }